import SvgClose from '@sats-group/icons/16/close';
import SvgBirthday from '@sats-group/icons/18/birthday';
import SvgDot from '@sats-group/icons/18/dot';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import Tag from '@sats-group/ui-lib/react/tag';
import Text from '@sats-group/ui-lib/react/text';
import clsx from 'clsx';
import React, { useState } from 'react';
import { Messages } from '~/source/ui/messages/messages';
import { RemoveMember } from '~/source/ui/remove-member/remove-member';
import type { Member as Props } from './member.page.types';

type OutcomeHandler = NonNullable<
  Parameters<typeof RemoveMember>[0]['onOutcome']
>;
type Outcome = Parameters<OutcomeHandler>[0];

export const Member: React.FC<Props> = ({
  actions,
  birthday,
  data,
  messages,
  name,
  status,
}) => {
  const [outcome, setOutcome] = useState<Outcome>();
  const handleOutcome: OutcomeHandler = _outcome => setOutcome(_outcome);

  return (
    <main className="member">
      <div
        className={clsx('member__header', {
          'member__header--removed': outcome === 'SUCCESS',
        })}
      >
        <div className="member__primary">
          <div className="member__name">
            <Text
              elementName="h1"
              size={Text.sizes.headline2}
              theme={Text.themes.emphasis}
              tight
            >
              {name}
            </Text>
            <div>
              <LinkButton
                {...actions.back}
                iconOnly
                leadingIcon={<SvgClose />}
                size={LinkButton.sizes.small}
                variant={LinkButton.variants.secondary}
              />
            </div>
          </div>
          <div className="member__meta">
            <div>
              <SvgBirthday />
            </div>
            <div>
              <Text size={Text.sizes.small} tight>
                {birthday}
              </Text>
            </div>
          </div>
        </div>
        <div className="member__secondary">
          <div>
            <Tag {...status} icon={<SvgDot />} />
          </div>
          <div>
            <RemoveMember {...actions.remove} onOutcome={handleOutcome} />
          </div>
        </div>
      </div>
      <div className="member__content">
        <div className="member__card">
          {data.map(entry => (
            <div className="member__card-entry" key={entry.label}>
              <div className="member__card-label">
                <Text size={Text.sizes.small}>{entry.label}</Text>
              </div>
              <Text>{entry.value}</Text>
            </div>
          ))}
        </div>
      </div>
      <Messages {...messages} />
    </main>
  );
};
